import { useQueryPublicApplications } from 'domains/trustedApps/hooks/useQueryPublicApplications'
import { Spinner, Text } from 'lib/components'
import React from 'react'
import { useParams } from 'react-router-dom'
import clsx from 'clsx'
import TrustedAppLogo from 'domains/trustedApps/components/TrustedAppsList/TrustedAppLogo'

const EmbeddableTrustedAppsScreen = () => {
  const params = useParams<{ orgId: string }>()
  const { data, loading, error } = useQueryPublicApplications({
    orgId: params.orgId,
  })

  if (error) {
    return (
      <div className="flex align-center justify-center py-6">
        <Text className="text-ta-gray-2">{error}</Text>
      </div>
    )
  }

  if (!data && loading) {
    return (
      <div className="flex align-center justify-center">
        <Spinner />
      </div>
    )
  }

  if (!data || (data.length === 0 && !loading)) {
    return (
      <div className="flex align-center justify-center py-6">
        <Text className="text-ta-gray-2">No rated applications found...</Text>
      </div>
    )
  }

  return (
    <div
      className="grid gap-y-2 py-3 px-3 bg-white"
      style={{ gridTemplateColumns: 'auto auto 1fr' }}
    >
      {data.map((app, index) => {
        return (
          <div
            key={index}
            className="grid col-span-3 items-center gap-3 py-2 px-2 shadow-md"
            style={{ gridTemplateColumns: 'subgrid' }}
          >
            <div className="flex space-x-4 items-center">
              <TrustedAppLogo title={app.title} logo={app.logo} />
              <Text className="text-lg font-bold ml-2 truncate">
                {app.title}
              </Text>
            </div>
            <div>
              {app.rating ? (
                <div className="inline-flex w-fit items-center gap-2 font-bold py-2 px-6 rounded-full border border-silver">
                  <i
                    className={clsx(`fas text-2xl`, app.rating.iconIdentifier)}
                    style={{ color: app.rating.iconColor }}
                  />
                  <Text>{app.rating.ratingText}</Text>
                </div>
              ) : (
                <i className="fas fa-minus text-2xl" color="ta-gray-2" />
              )}
            </div>

            <a
              href={app.privacyUrl}
              target="_blank"
              rel="noreferrer"
              className="ml-2 justify-self-end"
            >
              Privacy Policy
            </a>
          </div>
        )
      })}
    </div>
  )
}

export default EmbeddableTrustedAppsScreen
